export const EACH = 'each'
export const SET = 'set'

export const NAMES = {
  [EACH]: 'Per each Unit',
  [SET]: 'Per SKU or Set'
}
